export default "__VITE_ASSET__a2c8bf5d__"